var _defs, _polygon, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 325.82 205.22",
    transform: "translate(0 0) scale(1.5 1.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#4739ea;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "102.93 70.76 89.53 94.4 75.74 70.76 59.49 70.76 81.73 107.16 81.73 133.33 96.28 133.33 96.28 107.07 118.52 70.76 102.93 70.76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M144.44,113.07c0,2.5-.75,4.74-2.25,6.71-1.5,1.97-3.63,2.96-6.38,2.96-2.38,0-4.17-.72-5.39-2.16-1.22-1.44-1.83-3.41-1.83-5.91v-25.33h-13.51v27.3c0,5.88,1.48,10.32,4.46,13.32,2.97,3,6.96,4.5,11.96,4.5,2.56,0,5.02-.55,7.36-1.64,2.35-1.09,4.24-2.49,5.68-4.17l.38,4.69h12.95v-44h-13.41v23.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M194.46,88.31c-2.5,0-4.94,.53-7.32,1.59-2.38,1.06-4.28,2.47-5.72,4.22l-.38-4.78h-12.95v44h13.41v-23.64c0-2.56,.77-4.81,2.3-6.75,1.53-1.94,3.77-2.91,6.71-2.91,2.19,0,3.89,.72,5.11,2.16,1.22,1.44,1.83,3.38,1.83,5.82v25.33h13.51v-27.2c0-5.88-1.5-10.32-4.5-13.32s-7-4.5-12.01-4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M263.38,99.47c-1.97-3.56-4.72-6.39-8.25-8.49-3.53-2.09-7.65-3.14-12.34-3.14s-8.8,1.05-12.34,3.14c-3.53,2.1-6.3,4.92-8.3,8.49-2,3.56-3,7.5-3,11.82s1,8.26,3,11.82c1.68,2.99,4.55,6.23,7.31,8.21,7.24-5,19.22-5.49,27.11,0,2.7-1.96,5.18-5.26,6.81-8.21,1.97-3.56,2.96-7.5,2.96-11.82s-.99-8.26-2.96-11.82Zm-11.3,17.54c-.81,1.81-1.99,3.28-3.52,4.41-1.53,1.13-3.46,1.69-5.77,1.69s-4.17-.56-5.77-1.69c-1.59-1.13-2.8-2.59-3.61-4.41-.81-1.81-1.22-3.72-1.22-5.72s.41-3.89,1.22-5.68c.81-1.78,2.02-3.24,3.61-4.36,1.59-1.13,3.52-1.69,5.77-1.69s4.24,.56,5.77,1.69c1.53,1.13,2.7,2.58,3.52,4.36,.81,1.78,1.22,3.67,1.22,5.68s-.41,3.91-1.22,5.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee9303cb3cd8bfe8c5d8185398e93ac9.svg";
export { ForwardRef as ReactComponent };